/**
 * Default filter/dialog options served immediately (and as a resilient
 * fallback if the constants query fails), then refined from the API in
 * useInventoryConstants. Not test data — these keep filters and dialogs
 * usable before/without a successful constants fetch.
 */
import type { InventoryConstants } from './types';

export const DEFAULT_STATES: InventoryConstants['states'] = [
  { code: 'CREATED', displayName: 'Created' },
  { code: 'CATALOG_REVIEW', displayName: 'In Review for Catalog' },
  { code: 'FORSALE_REVIEW', displayName: 'In Review for Sale' },
  { code: 'FORSALE_APPROVED', displayName: 'Approved for Sale' },
  { code: 'FORSALE_UNLISTED', displayName: 'Approved but Unlisted' },
  { code: 'FORSALE_REJECTED', displayName: 'Rejected for Sale' },
  { code: 'PARTNER_REJECTED', displayName: 'Rejected for Partner' },
  { code: 'NEEDS_CLEANING', displayName: 'Needs Cleaning' },
  { code: 'CLEANING_IN_PROGRESS', displayName: 'Cleaning in Progress' },
  { code: 'NEEDS_REPAIR', displayName: 'Needs Repair' },
  { code: 'REPAIR_IN_PROGRESS', displayName: 'Repair in Progress' },
  { code: 'PHOTOGRAPHY_PENDING', displayName: 'Photography Pending' },
  { code: 'PHOTOGRAPHY_IN_PROGRESS', displayName: 'Photography in Progress' },
  { code: 'ORDERED', displayName: 'Ordered' },
  { code: 'PICKED', displayName: 'Picked' },
  { code: 'PACKED', displayName: 'Packed' },
  { code: 'SHIPPED', displayName: 'Shipped' },
  { code: 'SENDBACK_PENDING', displayName: 'Pending Sendback' },
  { code: 'MISSING', displayName: 'Missing' },
  { code: 'DAMAGED', displayName: 'Damaged' },
];

export const DEFAULT_CONDITIONS: InventoryConstants['conditions'] = [
  { code: 'GRADE_A', displayName: 'Like New' },
  { code: 'GRADE_B', displayName: 'Excellent' },
  { code: 'GRADE_C', displayName: 'Good' },
  { code: 'GRADE_D', displayName: 'Fair' },
];

export const DEFAULT_REJECT_REASONS: InventoryConstants['rejectReasons'] = [
  { code: 'DAMAGED', displayName: 'Damaged beyond repair' },
  { code: 'STAINED', displayName: 'Stained' },
  { code: 'NOT_AUTHENTIC', displayName: 'Could not authenticate' },
  { code: 'OUT_OF_SCOPE', displayName: 'Outside program scope' },
];
